import { useEffect } from 'react';
import { PostMessageType } from '@constants/postMessage';

// Số UI đang cần tràn trái (submenu, tooltip...) — chỉ báo host khi 0 → 1 và 1 → 0,
// tránh tooltip tắt làm cắt mất submenu vẫn đang mở.
let bleedRequestCount = 0;

const postBleed = (open: boolean) => {
  if (typeof window === 'undefined' || window.parent === window) return;
  window.parent.postMessage({ type: PostMessageType.CHAT_COMMAND_SUBMENU, open }, '*');
};

export const acquireEmbedSubmenuBleed = (): void => {
  bleedRequestCount += 1;
  if (bleedRequestCount !== 1) return;
  document.documentElement.classList.add('embed-command-submenu-bleed');
  postBleed(true);
};

export const releaseEmbedSubmenuBleed = (): void => {
  if (bleedRequestCount === 0) return;
  bleedRequestCount -= 1;
  if (bleedRequestCount !== 0) return;
  document.documentElement.classList.remove('embed-command-submenu-bleed');
  postBleed(false);
};

/**
 * Embed: khi một submenu mở sang trái panel chatbot, toggle class
 * `embed-command-submenu-bleed` và báo host (embed-chatbot-bubble.js) nới iframe sang trái
 * để submenu tràn ra ngoài khung 404px mà không bị cắt / không phải đè lên menu chính.
 */
export const useEmbedSubmenuBleed = (open: boolean): void => {
  useEffect(() => {
    if (!open || typeof window === 'undefined') return;
    acquireEmbedSubmenuBleed();
    return releaseEmbedSubmenuBleed;
  }, [open]);
};
